(function ($) {
  Drupal.behaviors.pcem_hero = {
    attach: function (context, settings) {
      $('#pc_em_mod1', context).once('pcem_hero', function () {
        var heroLoop;
        var imageCounterHero = 1;

        heroLoop = setInterval(function () {
          if (imageCounterHero < 4) {
            imageCounterHero++;
            $('.el_boutique_img_full').removeClass('imageShow');
            $('.el_boutique_img_full').addClass('imageHide');
            $('.el_boutique_img_hero' + imageCounterHero).removeClass('imageHide');
            $('.el_boutique_img_hero' + imageCounterHero).addClass('imageShow');
          } else {
            imageCounterHero = 1;
            $('.el_boutique_img_full').removeClass('imageShow');
            $('.el_boutique_img_full').addClass('imageHide');
            $('.el_boutique_img_hero' + imageCounterHero).removeClass('imageHide');
            $('.el_boutique_img_hero' + imageCounterHero).addClass('imageShow');
          }
        }, 1500);

        var heroTextLoop;
        var imageCounterHeroText = 1;

        heroTextLoop = setInterval(function () {
          if (imageCounterHeroText < 4) {
            imageCounterHeroText++;
            $('.pc_em_mod1_hero_txt').removeClass('imageShow');
            $('.pc_em_mod1_hero_txt').addClass('imageHide');
            $('.pc_em_mod1_hero_txt' + imageCounterHeroText).removeClass('imageHide');
            $('.pc_em_mod1_hero_txt' + imageCounterHeroText).addClass('imageShow');
          } else {
            imageCounterHeroText = 1;
            $('.pc_em_mod1_hero_txt').removeClass('imageShow');
            $('.pc_em_mod1_hero_txt').addClass('imageHide');
            $('.pc_em_mod1_hero_txt' + imageCounterHeroText).removeClass('imageHide');
            $('.pc_em_mod1_hero_txt' + imageCounterHeroText).addClass('imageShow');
          }
        }, 1500);

        /** ** VIDEO FUNCTIONALITY ****/
        // Players.
        var player1;
        // Video sources.
        var src1 = $('#pc_em_mod1_video_container').data('videoid');
        // Initialise YouTube API.
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];

        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // Execute as soon as the player API is ready.
        onYouTubeIframeAPIReady = function () {
          player1 = new YT.Player('pc_em_mod1_video_container', {
            height: '390',
            width: '640',
            videoId: src1,
            playerVars: {
              autohide: 1,
              autoplay: 0,
              color: 'red',
              cc_load_policy: 0,
              controls: 0,
              disablekb: 0,
              end: 0,
              wmode: 'transparent',
              fs: 1,
              loop: 0,
              html5: 1,
              playsinline: 1
            },
            events: {
              onReady: playerOneReady,
              onStateChange: onPlayerStateChangeOne
            }
          });
        };

        // When the Players are ready.
        var duration1;
        var videoInterval1, videoScrubber1;
        var close1 = $('#pc_em_mod1 .boutique__video_close_x');
        var playTrigger1 = $('#pc_em_mod1_play');
        var playPauseBtn;

        function playerOneReady() {
          duration1 = player1.getDuration();
          videoInterval1, (videoScrubber1 = $('#pc_em_mod1 .boutique__video_inner_scrubber'));
        }

        // Handle toggle of play/pause.
        function playPause(playerNum, whichBtn) {
          if (whichBtn.hasClass('active')) {
            playerNum.pauseVideo();
            whichBtn.removeClass('active');
          } else {
            whichBtn.addClass('active');
            playerNum.playVideo();
          }
        }

        // Toggle play/pause for first video.
        var playPauseBtn1 = $('#pc_em_mod1 .boutique__video_play_btn');

        playPauseBtn1.on('click', function () {
          playPause(player1, playPauseBtn1);
        });

        function onPlayerStateChangeOne(event) {
          if (event.data == YT.PlayerState.PLAYING) {
            playPauseBtn1.addClass('active');
          } else if (event.data == YT.PlayerState.PAUSED) {
            playPauseBtn1.removeClass('active');
          }
        }

        // Check for iPad.
        var isTouch = false;

        if (navigator.userAgent.match(/iPad/i) != null) {
          isTouch = true;
          $('body').addClass('isTouch');
        }

        // Check for IE.
        var isIE = false;

        if ($('body').hasClass('ie') || $('body').hasClass('ie-11')) {
          isIE = true;
        }
        if (isIE) {
          if ($('body').hasClass('isTouch')) {
            $('body').removeClass('isTouch');
          }
        }

        // Play the videos.
        function playEach(
          theNum,
          eachPlayerNum,
          eachInterval,
          eachDuration,
          eachScrubber,
          eachClose,
          eachEnd,
          src
        ) {
          $('#pc_em_mod' + theNum + '_video .boutique__video_close_x').show();
          $('#pc_em_mod' + theNum + '_video .boutique__video_controls_mask').show();
          $('#pc_em_mod' + theNum + '_video').fadeIn();
          $('#pc_em_mod' + theNum + '_video .boutique__video_play_btn').addClass('active');
          $('#pc_em_mod' + theNum + '_video_container').show();

          if (isTouch && !isIE) {
            $('#pc_em_mod' + theNum + '_video .boutique__video_controls_mask').hide();
          }
          scrubberAndPlay(
            eachPlayerNum,
            eachInterval,
            eachDuration,
            eachScrubber,
            eachClose,
            eachEnd
          );
        }

        playTrigger1.click(function () {
          playEach(1, player1, videoInterval1, duration1, videoScrubber1, close1, 1.4, src1);
        });

        // Handle the scrubber.
        function scrubberAndPlay(playerNum, vidInterval, duration, vidScrubber, close, closeTime) {
          playerNum.seekTo(0, true);
          playerNum.playVideo();

          vidInterval = setInterval(function () {
            var currentTime = playerNum.getCurrentTime(),
              multipliedTime = (currentTime / duration) * 100 + 3;

            vidScrubber.css('width', multipliedTime + '%');
            if (currentTime >= duration - closeTime) {
              close.click();

              return;
            }
          }, 30);
        }

        // Handle fullscreen option.
        function checkFullscreen(fullscreenNo) {
          $('#pc_em_mod' + fullscreenNo + ' .boutique__video_full_btn').click(function () {
            screenfull.request($('#pc_em_mod' + fullscreenNo + '_video_container')[0]);
          });
        }

        function hideFullscreen(fullscreenNo) {
          $('#pc_em_mod' + fullscreenNo + ' .boutique__video_full_btn').hide();
        }

        if (screenfull.enabled) {
          checkFullscreen(1);
        } else {
          hideFullscreen(1);
        }

        // Close the videos.
        function closePlayer(whichPlayer, playerNum, whichInterval) {
          whichPlayer.pauseVideo();
          whichPlayer.stopVideo();
          $('#pc_em_mod' + playerNum + '_video_container').hide();
          $('#pc_em_mod' + playerNum + '_video .boutique__video_close_x').hide();
          $('#pc_em_mod' + playerNum + '_video .boutique__video_controls_mask').hide();
          $('#pc_em_mod' + playerNum + '_video .boutique__video_play_btn').removeClass('active');
          clearInterval(whichInterval);
          $('#pc_em_mod' + playerNum + ' .boutique__video_top_video').fadeOut();
          $('.pc_em_hero_gif').animate({ opacity: '1' }, 100);
          $('html, body').animate(
            {
              scrollTop: $('#pc_em_mod2').offset().top - 80
            },
            900
          );
        }

        close1.click(function () {
          closePlayer(player1, 1, videoInterval1);
        });

        // Close the Share Overlay.
        $('#boutique__video_top-video-Share-XImg').click(function () {
          $('#boutique__video_top-video-Share').fadeOut(200);
        });

        $(window).on('load', function () {
          $('#pcem_spinner').fadeOut(400, function () {
            if ($.cookie('boutique__video-cookie') == null) {
              $('.pc_em_hero_gif').css('opacity', '0');
              $('#pc_em_mod1_play').click();
              $.cookie('boutique__video-cookie', true);
            } else {
              $('.pc_em_hero_gif').animate({ opacity: '1' }, 100);

              if ($(window).scrollTop() >= $('#pc_em_mod2').offset().top) {
                return;
              } else {
                $('html, body').animate(
                  {
                    scrollTop: $('#pc_em_mod2').offset().top - 80
                  },
                  900
                );
              }
            }
          });
        });
      });
    }
  };
})(jQuery);
